import { Droplets } from "lucide-react";
import type { FengniaoDashboard } from "../hooks/useFengniaoDashboard";
import { formatBnb, formatToken } from "../lib/format";

interface HolderLpPanelProps {
  dashboard: FengniaoDashboard;
}

interface StatRow {
  label: string;
  value: string;
  accent?: string;
}

export function HolderLpPanel({ dashboard }: HolderLpPanelProps) {
  const { token, holderLp } = dashboard;
  const stats = holderLp.stats;

  const rows: StatRow[] = [
    {
      label: "已登记持币",
      value: formatToken(holderLp.registeredBalance, token.symbol, token.decimals),
    },
    {
      label: "可领 LP",
      value: formatToken(holderLp.claimable, "LP"),
      accent: holderLp.claimable > 0n ? "text-wing" : undefined,
    },
    {
      label: "持币门槛",
      value: formatToken(holderLp.minHolding, token.symbol, token.decimals),
    },
    { label: "Vault BNB", value: formatBnb(stats?.[4] ?? 0n) },
    { label: "已分发 LP", value: formatToken(stats?.[2] ?? 0n, "LP") },
    { label: "参与人数", value: (stats?.[1] ?? 0n).toString() },
  ];

  return (
    <section className="glass p-5 lg:p-6">
      <header className="flex items-center gap-2.5 mb-2">
        <Droplets className="w-5 h-5 text-wing" strokeWidth={1.75} aria-hidden />
        <h3 className="text-sm font-mono uppercase tracking-wider text-ink">
          持币分红 LP
        </h3>
      </header>
      <p className="text-xs text-ink-dim leading-relaxed mb-5">
        持币达到门槛后，蜂鸟会用税收帮你买回代币、配 LP，再按你的持币比例发到账户。
      </p>

      <dl className="grid gap-x-6 gap-y-3 lg:grid-cols-2">
        {rows.map((row) => (
          <div key={row.label} className="flex items-baseline justify-between gap-3 border-b border-white/[0.04] pb-2">
            <dt className="text-xs text-ink-dim shrink-0">{row.label}</dt>
            <dd
              className={`text-sm font-mono tabular-nums text-right break-all ${row.accent ?? "text-ink"}`}
            >
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
